<div>
  <p>
    <strong>
      <span style="font-size: 16pt;">About Gambit</span>
    </strong>
  </p>
  <p style="line-height: 16.8pt; background: white; margin: 0in 0in 12.0pt 0in;">
    <span style="font-size: 14.5pt; font-family: 'Gill Sans MT',sans-serif; color: #404040;">Established in 2016, Gamebit is a software-as-a-service company in Portland, Oregon. We showcase real world examples
      of software designs, alongside resources and articles that teach you how to enjoy and have fun in writing software.
      &nbsp;</span>
  </p>
  <p style="line-height: 16.8pt; background: white; margin: 0in 0in 12.0pt 0in;">
    <span style="font-size: 14.5pt; font-family: 'Gill Sans MT',sans-serif; color: #404040;">We specialize in game development, AI, and data analytics. </span>
  </p>
</div>


// WEBPACK FOOTER //
// ./src/app/ui/about-us-page/about-us-page.component.html